import globalState from '../state';
import CONSTANTS from '../constants';

let initialStateSol = globalState.solicitacao;

let grupoFamiliar = (state = initialStateSol.grupoFamiliar, action) => {
    var payload = action.payload;

    var acoes = {
        [CONSTANTS.CHANGE_CAMPO_GENERICO_GRUPO_FAMILIAR]: () => {

            var obj = {
                [action.payload.campoState]: action.payload.valor
            };

            return { ...state, ...obj };
        },

        [CONSTANTS.ADD_PESSOA_NO_GRUPO_FAMILIAR]: () => {
            return { ...state, listFamiliar: [...state.listFamiliar, payload] };
        },

        [CONSTANTS.DELETE_PESSOA_NO_GRUPO_FAMILIAR]: () => {
            return {
                ...state, listFamiliar: state.listFamiliar.filter((item, indice) => {
                    return indice !== payload.indice;
                })
            };
        },

        [CONSTANTS.UPDATE_PESSOA_NO_GRUPO_FAMILIAR]: () => {
            return {
                ...state, listFamiliar: state.listFamiliar.map((item, indice) => {
                    return indice !== payload.indice ? item : payload.item;
                })
            };
        },

        [CONSTANTS.CARREGAR_LIST_TPMORADIA.SUCCESS]: () => {
            return { ...state, listTpMoradia: payload };
        },

        [CONSTANTS.CARREGAR_LIST_PARENTESCO.SUCCESS]: () => {
            return { ...state, listParentesco: payload };
        },

        [CONSTANTS.SET_LIST_GRUPO_FAMILIAR]: () => {
            return { ...state, listFamiliar: [...payload] };
        },

        [CONSTANTS.ADD_ITEM_ARQUIVO_FAMILIAR]: () => {
            return {
                ...state,
                listArquivosGrupoFamiliar: [...state.listArquivosGrupoFamiliar, {
                    UplOrigem: 'G'.charCodeAt(0),
                    UplDescricao: payload.UplDescricao,
                    UplArquivo: payload.UplArquivo,//bytes
                
           
                }]
            };
        },

        [CONSTANTS.REMOVE_ITEM_ARQUIVO_FAMILIAR]: () => {
            return {
                ...state, listArquivosGrupoFamiliar: state.listArquivosGrupoFamiliar.filter((item, indice) => {
                    return indice !== payload.indice;
                })
            };
        },

        [CONSTANTS.UPDATE_ITEM_ARQUIVO_FAMILIAR]: () => {
            return {
                ...state, listArquivosGrupoFamiliar: state.listArquivosGrupoFamiliar.map((item, indice) => {
                    return indice !== payload.indice ? item : {
                        UplOrigem: 'G'.charCodeAt(0),
                        UplDescricao: payload.UplDescricao,
                        UplArquivo: payload.UplArquivo,//bytes
                      
            
                    };
                })
            };
        } 

    };
    if (acoes[action.type]) {
        return acoes[action.type]();
    }
    return state;

};




export default grupoFamiliar;


// WEBPACK FOOTER //
// ./src/reducers/grupo-familiar.js